import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import { linkedInPosts } from '../utils/mockData';
import { TrendingUpIcon, UsersIcon, MessageSquareIcon, ThumbsUpIcon } from 'lucide-react';
const engagementData = [{
  name: 'Mon',
  likes: 42,
  comments: 18,
  shares: 5
}, {
  name: 'Tue',
  likes: 63,
  comments: 24,
  shares: 12
}, {
  name: 'Wed',
  likes: 87,
  comments: 31,
  shares: 15
}, {
  name: 'Thu',
  likes: 52,
  comments: 19,
  shares: 8
}, {
  name: 'Fri',
  likes: 91,
  comments: 35,
  shares: 20
}, {
  name: 'Sat',
  likes: 75,
  comments: 28,
  shares: 17
}, {
  name: 'Sun',
  likes: 49,
  comments: 15,
  shares: 6
}];
const leadConversionData = [{
  name: 'Week 1',
  leads: 24,
  conversions: 3
}, {
  name: 'Week 2',
  leads: 32,
  conversions: 5
}, {
  name: 'Week 3',
  leads: 38,
  conversions: 7
}, {
  name: 'Week 4',
  leads: 45,
  conversions: 12
}];
export const AnalyticsPanel: React.FC = () => {
  // Calculate total engagement metrics
  const totalLikes = linkedInPosts.reduce((sum, post) => sum + post.likes, 0);
  const totalComments = linkedInPosts.reduce((sum, post) => sum + post.comments, 0);
  const totalShares = linkedInPosts.reduce((sum, post) => sum + post.shares, 0);
  const totalEngagements = totalLikes + totalComments + totalShares;
  // Calculate average engagement per post
  const averageLikes = Math.round(totalLikes / linkedInPosts.length);
  const averageComments = Math.round(totalComments / linkedInPosts.length);
  const averageEngagement = Math.round(totalEngagements / linkedInPosts.length);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6" data-id="element-50">
      <h2 className="text-xl font-medium text-gray-900 mb-6" data-id="element-51">
        Engagement Analytics
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-52">
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100" data-id="element-53">
          <div className="flex items-center" data-id="element-54">
            <div className="p-2 rounded-full bg-blue-100 mr-3" data-id="element-55">
              <ThumbsUpIcon size={20} className="text-blue-600" data-id="element-56" />
            </div>
            <div data-id="element-57">
              <p className="text-sm font-medium text-gray-500" data-id="element-58">Total Likes</p>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-59">{totalLikes}</h3>
            </div>
          </div>
          <div className="mt-2 text-xs text-green-600 flex items-center" data-id="element-60">
            <TrendingUpIcon size={12} className="mr-1" data-id="element-61" />
            <span data-id="element-62">+{averageLikes} avg per post</span>
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100" data-id="element-63">
          <div className="flex items-center" data-id="element-64">
            <div className="p-2 rounded-full bg-purple-100 mr-3" data-id="element-65">
              <MessageSquareIcon size={20} className="text-purple-600" data-id="element-66" />
            </div>
            <div data-id="element-67">
              <p className="text-sm font-medium text-gray-500" data-id="element-68">
                Total Comments
              </p>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-69">
                {totalComments}
              </h3>
            </div>
          </div>
          <div className="mt-2 text-xs text-green-600 flex items-center" data-id="element-70">
            <TrendingUpIcon size={12} className="mr-1" data-id="element-71" />
            <span data-id="element-72">+{averageComments} avg per post</span>
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100" data-id="element-73">
          <div className="flex items-center" data-id="element-74">
            <div className="p-2 rounded-full bg-[#f9b30f33] mr-3" data-id="element-75">
              <UsersIcon size={20} className="text-[#f9b30f]" data-id="element-76" />
            </div>
            <div data-id="element-77">
              <p className="text-sm font-medium text-gray-500" data-id="element-78">
                Potential Leads
              </p>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-79">38</h3>
            </div>
          </div>
          <div className="mt-2 text-xs text-green-600 flex items-center" data-id="element-80">
            <TrendingUpIcon size={12} className="mr-1" data-id="element-81" />
            <span data-id="element-82">+12% from last month</span>
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-100" data-id="element-83">
          <div className="flex items-center" data-id="element-84">
            <div className="p-2 rounded-full bg-green-100 mr-3" data-id="element-85">
              <TrendingUpIcon size={20} className="text-green-600" data-id="element-86" />
            </div>
            <div data-id="element-87">
              <p className="text-sm font-medium text-gray-500" data-id="element-88">
                Avg. Engagement
              </p>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-89">
                {averageEngagement}
              </h3>
            </div>
          </div>
          <div className="mt-2 text-xs text-green-600 flex items-center" data-id="element-90">
            <TrendingUpIcon size={12} className="mr-1" data-id="element-91" />
            <span data-id="element-92">+8% from last week</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-93">
        <div data-id="element-94">
          <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-95">
            Daily Engagement
          </h3>
          <div className="h-64" data-id="element-96">
            <ResponsiveContainer width="100%" height="100%" data-id="element-97">
              <BarChart data={engagementData} margin={{
              top: 5,
              right: 30,
              left: 0,
              bottom: 5
            }} data-id="element-98">
                <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-99" />
                <XAxis dataKey="name" data-id="element-100" />
                <YAxis data-id="element-101" />
                <Tooltip data-id="element-102" />
                <Bar dataKey="likes" fill="#4f46e5" name="Likes" data-id="element-103" />
                <Bar dataKey="comments" fill="#8b5cf6" name="Comments" data-id="element-104" />
                <Bar dataKey="shares" fill="#f9b30f" name="Shares" data-id="element-105" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div data-id="element-106">
          <h3 className="text-md font-medium text-gray-700 mb-2" data-id="element-107">
            Lead Conversion
          </h3>
          <div className="h-64" data-id="element-108">
            <ResponsiveContainer width="100%" height="100%" data-id="element-109">
              <LineChart data={leadConversionData} margin={{
              top: 5,
              right: 30,
              left: 0,
              bottom: 5
            }} data-id="element-110">
                <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-111" />
                <XAxis dataKey="name" data-id="element-112" />
                <YAxis data-id="element-113" />
                <Tooltip data-id="element-114" />
                <Line type="monotone" dataKey="leads" stroke="#4f46e5" name="Leads" data-id="element-115" />
                <Line type="monotone" dataKey="conversions" stroke="#f9b30f" name="Conversions" strokeWidth={2} data-id="element-116" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
};